export default __webpack_public_path__ + "question-mark-small.34d2a060fd26a348.svg";